export default "__VITE_ASSET__DoArprIP__"